













































import {Component, Watch, Mixins, Vue} from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class'
import {$, PageCollection, pushByName} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import {MixinSelect} from '@/components/mixins/MixinSelect'
import {AppConfig} from '@/config/app.config'
import {Role} from '@/enums/Role'
import Responsavel from '@/model/resource/Responsavel'
import ChecklistEntrega from '../../model/resource/ChecklistEntrega'
import {snakeCase} from 'lodash'
import * as Helper from '@/helpers'

const metaInfo = () => ({
    title: $.t('view.manage.checkListEntrega.title'),
})

@Component({
    metaInfo,
})
export default class ManageChecklistEntregaView extends Mixins(MixinFilter, MixinSelect) {
    @Getter('auth/role') role!: Role
    @Getter('auth/responsavel') user!: Responsavel

    Role = Role
    AppConfig = AppConfig
    pushByName = pushByName

    collection = new PageCollection(ChecklistEntrega, {}, 10)

    created() {
        this.collection.endpoint = '/user/checklist-entrega'
    }

    async downloadData(xlsx: boolean) {
        if (!xlsx) {
            const csv = new PageCollection(ChecklistEntrega, {}, null, null)

            const fetch = async () => await csv.search()
            await $.await.run(fetch, 'download')
            csv.downloadCsv($.t('view.manage.checkListEntrega.title'))
        } else {
            await $.await.run(() => Helper.downloadXlsx(
                $.t('view.manage.checkListEntrega.title'),
                '/user/carga/checklistType/csv',
                null,
                ChecklistEntrega,
                'ChecklistEntrega',
            ), 'download')
        }
    }
}
